import React from "react";

function BS4_Home() {
  return (
    <div>
      <h1>BS4_Home Component</h1>
      <p>This is the BS4_Home tutorial page content.</p>
    </div>
  );
}

export default BS4_Home;
